import logo from './../assets/img/icons/logo.svg';
import logoWhite from './../assets/img/icons/logo-white.svg';
import arrowArc from './../assets/img/icons/arrow-arc.svg';


//img
import tumba1 from './../assets/img/firstStage/1.png';
import tumba2 from './../assets/img/firstStage/2.png';
import tumba3 from './../assets/img/firstStage/3.png';
import tumba4 from './../assets/img/firstStage/4.png';
import tumba5 from './../assets/img/firstStage/5.png';
import tumba6 from './../assets/img/firstStage/6.png';

//selectImg
import storm from './../assets/img/select-picture/storm.png';
import calacatta from './../assets/img/select-picture/calacatta.png';
import negro from './../assets/img/select-picture/negro.png';

//modalWindos
import shown1 from './../assets/img/modal-window-img/shown1.png';
import shown2 from './../assets/img/modal-window-img/shown2.png'
import shown3 from './../assets/img/modal-window-img/shown3.png'

//constructor
import sink from './../assets/img/constructor/sink.png';
import stand from './../assets/img/constructor/stand.png';
import bg from './../assets/img/constructor/bg.png';



//sink choice


//sliders
import Apex from './../assets/img/sliders/Apex/Apex.jpg';
import Apex1 from './../assets/img/sliders/Apex/Apex1.jpg';
import Apex2 from './../assets/img/sliders/Apex/Apex2.jpg';

import Barno from './../assets/img/sliders/Barno/Barno/Barno.jpg';
import Barno1 from './../assets/img/sliders/Barno/Barno/Barno1.jpg';
import Barno2 from './../assets/img/sliders/Barno/Barno/Barno2.jpg';

import Barno_Center from './../assets/img/sliders/Barno/Barno_Center/Barno_Center.jpg';
import Barno_Center1 from './../assets/img/sliders/Barno/Barno_Center/Barno_Center1.jpg';
import Barno_Center2 from './../assets/img/sliders/Barno/Barno_Center/Barno_Center2.jpg';

import Barno_Combo from './../assets/img/sliders/Barno/Barno_Combo/Barno_Combo.jpg';
import Barno_Combo1 from './../assets/img/sliders/Barno/Barno_Combo/Barno_Combo1.jpg';
import Barno_Combo2 from './../assets/img/sliders/Barno/Barno_Combo/Barno_Combo2.jpg';

import Barno_Compact from './../assets/img/sliders/Barno/Barno_Compact/Barno_Compact.jpg';
import Barno_Compact1 from './../assets/img/sliders/Barno/Barno_Compact/Barno_Compact1.jpg';
import Barno_Compact2 from './../assets/img/sliders/Barno/Barno_Compact/Barno_Compact2.jpg';

import Barno_Penal from './../assets/img/sliders/Barno/Barno_Penal/Barno_Penal.jpg';
import Barno_Penal1 from './../assets/img/sliders/Barno/Barno_Penal/Barno_Penal1.jpg';
import Barno_Penal2 from './../assets/img/sliders/Barno/Barno_Penal/Barno_Penal2.jpg';

import Barno_Plus from './../assets/img/sliders/Barno/Barno_Plus/Barno_Plus.jpg';
import Barno_Plus1 from './../assets/img/sliders/Barno/Barno_Plus/Barno_Plus1.jpg';
import Barno_Plus2 from './../assets/img/sliders/Barno/Barno_Plus/Barno_Plus2.jpg';

import Barno_Two from './../assets/img/sliders/Barno/Barno_Two/Barno_Two.jpg';
import Barno_Two1 from './../assets/img/sliders/Barno/Barno_Two/Barno_Two1.jpg';
import Barno_Two2 from './../assets/img/sliders/Barno/Barno_Two/Barno_Two2.jpg';

import Barno_TwoPlus from './../assets/img/sliders/Barno/Barno_TwoPlus/Barno_TwoPlus.jpg';
import Barno_TwoPlus1 from './../assets/img/sliders/Barno/Barno_TwoPlus/Barno_TwoPlus1.jpg';
import Barno_TwoPlus2 from './../assets/img/sliders/Barno/Barno_TwoPlus/Barno_TwoPlus2.jpg';

import Bravo from './../assets/img/sliders/Bravo/Bravo/Bravo.jpg';
import Bravo1 from './../assets/img/sliders/Bravo/Bravo/Bravo1.jpg';
import Bravo2 from './../assets/img/sliders/Bravo/Bravo/Bravo2.jpg';

import Bravo_Plus from './../assets/img/sliders/Bravo/Bravo_Plus/Bravo_Plus.jpg';
import Bravo_Plus1 from './../assets/img/sliders/Bravo/Bravo_Plus/Bravo_Plus1.jpg';
import Bravo_Plus2 from './../assets/img/sliders/Bravo/Bravo_Plus/Bravo_Plus2.jpg';

import Charisma from './../assets/img/sliders/Charisma/Charisma/Charisma.jpg';
import Charisma1 from './../assets/img/sliders/Charisma/Charisma/Charisma1.jpg';
import Charisma2 from './../assets/img/sliders/Charisma/Charisma/Charisma2.jpg';

import Charisma_Plus from './../assets/img/sliders/Charisma/Charisma_Plus/Charisma_Plus.jpg';
import Charisma_Plus1 from './../assets/img/sliders/Charisma/Charisma_Plus/Charisma_Plus1.jpg';
import Charisma_Plus2 from './../assets/img/sliders/Charisma/Charisma_Plus/Charisma_Plus2.jpg';

import Clio from './../assets/img/sliders/Clio/Clio.jpg';
import Clio1 from './../assets/img/sliders/Clio/Clio1.jpg';
import Clio2 from './../assets/img/sliders/Clio/Clio2.jpg';

import Como from './../assets/img/sliders/Como/Como/Como.jpg';
import Como1 from './../assets/img/sliders/Como/Como/Como1.jpg';
import Como2 from './../assets/img/sliders/Como/Como/Como2.jpg';

import Como_Center from './../assets/img/sliders/Como/Como_Center/Como_Center.jpg';
import Como_Center1 from './../assets/img/sliders/Como/Como_Center/Como_Center1.jpg';
import Como_Center2 from './../assets/img/sliders/Como/Como_Center/Como_Center2.jpg';

import Como_Combo from './../assets/img/sliders/Como/Como_Combo/Como_Combo.jpg';
import Como_Combo1 from './../assets/img/sliders/Como/Como_Combo/Como_Combo1.jpg';
import Como_Combo2 from './../assets/img/sliders/Como/Como_Combo/Como_Combo2.jpg';

import Como_One from './../assets/img/sliders/Como/Como_One/Como_One.jpg';
import Como_One1 from './../assets/img/sliders/Como/Como_One/Como_One1.jpg';
import Como_One2 from './../assets/img/sliders/Como/Como_One/Como_One2.jpg';

import Como_Plus from './../assets/img/sliders/Como/Como_Plus/Como_Plus.jpg';
import Como_Plus1 from './../assets/img/sliders/Como/Como_Plus/Como_Plus1.jpg';
import Como_Plus2 from './../assets/img/sliders/Como/Como_Plus/Como_Plus2.jpg';

import Como_Two from './../assets/img/sliders/Como/Como_Two/Como_Two.jpg';
import Como_Two1 from './../assets/img/sliders/Como/Como_Two/Como_Two1.jpg';
import Como_Two2 from './../assets/img/sliders/Como/Como_Two/Como_Two2.jpg';

import Como_TwoPlus from './../assets/img/sliders/Como/Como_TwoPlus/Como_TwoPlus.jpg';
import Como_TwoPlus1 from './../assets/img/sliders/Como/Como_TwoPlus/Como_TwoPlus1.jpg';
import Como_TwoPlus2 from './../assets/img/sliders/Como/Como_TwoPlus/Como_TwoPlus2.jpg';

import Flap from './../assets/img/sliders/Flap/Flap.jpg';
import Flap1 from './../assets/img/sliders/Flap/Flap1.jpg';
import Flap2 from './../assets/img/sliders/Flap/Flap2.jpg';

import Japo from './../assets/img/sliders/Japo/Japo.jpg';
import Japo1 from './../assets/img/sliders/Japo/Japo1.jpg';
import Japo2 from './../assets/img/sliders/Japo/Japo2.jpg';

import Mono from './../assets/img/sliders/Mono/Mono/Mono.jpg';
import Mono1 from './../assets/img/sliders/Mono/Mono/Mono1.jpg';
import Mono2 from './../assets/img/sliders/Mono/Mono/Mono2.jpg';

import Mono_Center from './../assets/img/sliders/Mono/Mono_Center/Mono_Center.jpg';
import Mono_Center1 from './../assets/img/sliders/Mono/Mono_Center/Mono_Center1.jpg';
import Mono_Center2 from './../assets/img/sliders/Mono/Mono_Center/Mono_Center2.jpg';

import Mono_Combo from './../assets/img/sliders/Mono/Mono_Combo/Mono_Combo.jpg';
import Mono_Combo1 from './../assets/img/sliders/Mono/Mono_Combo/Mono_Combo1.jpg';
import Mono_Combo2 from './../assets/img/sliders/Mono/Mono_Combo/Mono_Combo2.jpg';

import Mono_Compact from './../assets/img/sliders/Mono/Mono_Compact/Mono_Compact.jpg';
import Mono_Compact1 from './../assets/img/sliders/Mono/Mono_Compact/Mono_Compact1.jpg';
import Mono_Compact2 from './../assets/img/sliders/Mono/Mono_Compact/Mono_Compact2.jpg';

import Mono_Penal from './../assets/img/sliders/Mono/Mono_Penal/Mono_Penal.jpg';
import Mono_Penal1 from './../assets/img/sliders/Mono/Mono_Penal/Mono_Penal1.jpg';
import Mono_Penal2 from './../assets/img/sliders/Mono/Mono_Penal/Mono_Penal2.jpg';

import Mono_Plus from './../assets/img/sliders/Mono/Mono_Plus/Mono_Plus.jpg';
import Mono_Plus1 from './../assets/img/sliders/Mono/Mono_Plus/Mono_Plus1.jpg';
import Mono_Plus2 from './../assets/img/sliders/Mono/Mono_Plus/Mono_Plus2.jpg';

import Mono_Two from './../assets/img/sliders/Mono/Mono_Two/Mono_Two.jpg';
import Mono_Two1 from './../assets/img/sliders/Mono/Mono_Two/Mono_Two1.jpg';
import Mono_Two2 from './../assets/img/sliders/Mono/Mono_Two/Mono_Two2.jpg';

import Mono_TwoPlus from './../assets/img/sliders/Mono/Mono_TwoPlus/Mono_TwoPlus.jpg';
import Mono_TwoPlus1 from './../assets/img/sliders/Mono/Mono_TwoPlus/Mono_TwoPlus1.jpg';
import Mono_TwoPlus2 from './../assets/img/sliders/Mono/Mono_TwoPlus/Mono_TwoPlus2.jpg';

import One from './../assets/img/sliders/One/One/One.jpg';
import One1 from './../assets/img/sliders/One/One/One1.jpg';
import One2 from './../assets/img/sliders/One/One/One2.jpg';

import One_Plus from './../assets/img/sliders/One/One_Plus/One_Plus.jpg';
import One_Plus1 from './../assets/img/sliders/One/One_Plus/One_Plus1.jpg';
import One_Plus2 from './../assets/img/sliders/One/One_Plus/One_Plus2.jpg';

import Viva from './../assets/img/sliders/Viva/Viva/Viva.jpg';
import Viva1 from './../assets/img/sliders/Viva/Viva/Viva1.jpg';
import Viva2 from './../assets/img/sliders/Viva/Viva/Viva2.jpg';

import Viva_Plus from './../assets/img/sliders/Viva/Viva_Plus/Viva_Plus.jpg';
import Viva_Plus1 from './../assets/img/sliders/Viva/Viva_Plus/Viva_Plus1.jpg';
import Viva_Plus2 from './../assets/img/sliders/Viva/Viva_Plus/Viva_Plus2.jpg';

//config one stage
import defaultConfigApex from './../assets/img/configuration/Apex.jpg';
import defaultConfigBarnoPlus from './../assets/img/configuration/BarnoPlus.jpg';
import defaultConfigBravo from './../assets/img/configuration/Bravo.jpg';
import defaultConfigCharismaPlus from './../assets/img/configuration/CharismaPlus.jpg';
import defaultConfigClioPlus from './../assets/img/configuration/ClioPlus.jpg';
import defaultConfigComoTwoPlus from './../assets/img/configuration/ComoTwoPlus.jpg';
import defaultConfigFlap from './../assets/img/configuration/Flap.jpg';
import defaultConfigJapoPlus from './../assets/img/configuration/JapoPlus.jpg';
import defaultConfigMonoPlus from './../assets/img/configuration/MonoPlus.jpg';
import defaultConfigOne from './../assets/img/configuration/One.jpg';
import defaultConfigVivaPlus from './../assets/img/configuration/VivaPlus.jpg';




const defaultConfig = {
    apex: defaultConfigApex,
    barnoPlus: defaultConfigBarnoPlus,
    bravo: defaultConfigBravo,
    charismaPlus: defaultConfigCharismaPlus,
    clioPlus: defaultConfigClioPlus,
    comoTwoPlus: defaultConfigComoTwoPlus,
    flap: defaultConfigFlap,
    japoPlus: defaultConfigJapoPlus,
    monoPlus: defaultConfigMonoPlus,
    one: defaultConfigOne,
    vivaPlus: defaultConfigVivaPlus,
}

const slider = {
    Apex: [Apex, Apex1, Apex2],
    Barno: [Barno, Barno1, Barno2],
    Barno_Center: [Barno_Center, Barno_Center1, Barno_Center2],
    Barno_Combo: [Barno_Combo, Barno_Combo1, Barno_Combo2],
    Barno_Compact: [Barno_Compact, Barno_Compact1, Barno_Compact2],
    Barno_Penal: [Barno_Penal, Barno_Penal1, Barno_Penal2],
    Barno_Plus: [Barno_Plus, Barno_Plus1, Barno_Plus2],
    Barno_Two: [Barno_Two, Barno_Two1, Barno_Two2],
    Barno_TwoPlus: [Barno_TwoPlus, Barno_TwoPlus1, Barno_TwoPlus2],
    Bravo: [Bravo, Bravo1, Bravo2],
    Bravo_Plus: [Bravo_Plus, Bravo_Plus1, Bravo_Plus2],
    Charisma: [Charisma, Charisma1, Charisma2],
    Charisma_Plus: [Charisma_Plus, Charisma_Plus1, Charisma_Plus2],
    Clio: [Clio, Clio1, Clio2],
    Como: [Como, Como1, Como2],
    Como_Center: [Como_Center, Como_Center1, Como_Center2],
    Como_Combo: [Como_Combo, Como_Combo1, Como_Combo2],
    Como_One: [Como_One, Como_One1, Como_One2],
    Como_Plus: [Como_Plus, Como_Plus1, Como_Plus2],
    Como_Two: [Como_Two, Como_Two1, Como_Two2],
    Como_TwoPlus: [Como_TwoPlus, Como_TwoPlus1, Como_TwoPlus2],
    Flap: [Flap, Flap1, Flap2],
    Japo: [Japo, Japo1, Japo2],
    Mono: [Mono, Mono1, Mono2],
    Mono_Center: [Mono_Center, Mono_Center1, Mono_Center2],
    Mono_Combo: [Mono_Combo, Mono_Combo1, Mono_Combo2],
    Mono_Compact: [Mono_Compact, Mono_Compact1, Mono_Compact2],
    Mono_Penal: [Mono_Penal, Mono_Penal1, Mono_Penal2],
    Mono_Plus: [Mono_Plus, Mono_Plus1, Mono_Plus2],
    Mono_Two: [Mono_Two, Mono_Two1, Mono_Two2],
    Mono_TwoPlus: [Mono_TwoPlus, Mono_TwoPlus1, Mono_TwoPlus2],
    One: [One, One1, One2],
    One_Plus: [One_Plus, One_Plus1, One_Plus2],
    Viva: [Viva, Viva1, Viva2],
    Viva_Plus: [Viva_Plus, Viva_Plus1, Viva_Plus2]
}


const icons = {
    logo: logo,
    logoWhite: logoWhite,
    arrowArc: arrowArc,
}

const img = {
    tumba1: tumba1,
    tumba2: tumba2,
    tumba3: tumba3,
    tumba4: tumba4,
    tumba5: tumba5,
    tumba6: tumba6,
}

const selectImg = {
    storm: storm,
    calacatta: calacatta,
    negro: negro
}

const modalImg = {
    shown1: shown1,
    shown2: shown2,
    shown3: shown3
}

const constructor = {
    sink: sink,
    mirror: "",
    stand: stand,
    bg: bg
}



export {icons, img, selectImg, modalImg, constructor, slider, defaultConfig}